module.exports = __webpack_public_path__ + "img/pepper-badge-large.e15dd829.svg";